import formDesign from './_src/formDesign.vue'
formDesign.install = function(Vue) {
  Vue.component(formDesign.name, formDesign)
}

export default formDesign